<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style=" border-radius: 5px !important;padding-left:0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousFFView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Air Freight Import</b-navbar-brand>
        </b-navbar>
        <banner-component :allModuleIdBanner="this.ffExoprtDetail.allModuleId ? this.ffExoprtDetail.allModuleId : ''"
          :jobSeriesBanner="this.ffExoprtDetail.airImportSeries ? this.ffExoprtDetail.airImportSeries : ''"
          :bannerClientName="this.multipleHouseBLData[0].ImporterName ? this.multipleHouseBLData[0].ImporterName : '' "
          iconId="fa fa-ship" />
        <b-card class="formCard">
          <b-card-text>
            <!-- <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="90"></md-layout>
              <md-layout md-flex="10">
                <md-button
                  v-if="ffExoprtDetail.ffairImportId"
                  @click="addStatus"
                  style="position: fixed;z-index:999;top:83%;"
                  class="md-fab"
                >
                  <md-icon>message</md-icon>
                </md-button>
              </md-layout>
            </md-layout> -->

            <md-layout md-gutter class="labelMargtop">
              <!-- <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="15">
                <label for="transportType">Import</label>
                <model-list-select
                  :list="transportTypeList"
                  isDisabled
                  v-model="ffExoprtDetail.transportType"
                  option-value="transportTypeVal"
                  option-text="transportTypeText"
                  placeholder="Select  Type"
                ></model-list-select>
              </md-layout>-->

              <md-layout md-flex="20">
                <label for="containerInfo">FF Activity</label>
                <model-list-select :list="containerInfoList" v-model="ffExoprtDetail.containerInfo"
                  option-value="containerInfoVal" option-text="containerInfoText" placeholder="Select"
                  :isDisabled="ffExoprtDetail.ffairImportId==''?false:true"></model-list-select>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="30">
                <label for="airlineId">AirLine Name</label>
                <model-list-select isDisabled :list="shippingList" v-model="ffExoprtDetail.airlineId"
                  option-value="airlineId" option-text="airlineName" placeholder="Select AirLine "></model-list-select>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <label>Date of Flight</label>
                <date-picker :format="selectDateFormat" lang="en" id="sailDate" name="sailDate"
                  v-model="ffExoprtDetail.flightDate"></date-picker>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Pre-Alert Received Date</label>
                <date-picker :format="selectDateFormat" lang="en" id="alertReceivedDate" name="alertReceivedDate"
                  v-model="ffExoprtDetail.alertReceivedDate"></date-picker>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="labelMargtop">

              <md-layout md-flex="45">
                <span class="error" v-if="!ffExoprtDetail.containerInfo">{{ffExporterrorList.containerInfo}}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="labelMargtop">


              <md-layout md-flex="60">
                <span class="error" v-if="!ffExoprtDetail.airlineId">{{ffExporterrorList.airlineId}}</span>
              </md-layout>
              <md-layout md-flex="20">
                <span class="error" v-if="!ffExoprtDetail.flightDate">{{ffExporterrorList.flightDate}}</span>
              </md-layout>
              <md-layout md-flex="20">
                <span class="error"
                  v-if="!ffExoprtDetail.alertReceivedDate">{{ffExporterrorList.alertReceivedDate}}</span>
              </md-layout>
            </md-layout>

            <!-- <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <label>Air B/L Number</label>
                <b-form-input :formatter="capitalizeAll"
                  id="firstBLNumber"
                  name="firstBLNumber"
                  v-model="ffExoprtDetail.firstBLNumber"
                  @keyup="containerNoRegexfun"
                ></b-form-input>
              
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <label>B/L Date</label>
                <date-picker
                  lang="en"
                  id="firstBLDate"
                  name="firstBLDate"
                  v-model="ffExoprtDetail.firstBLDate"
                ></date-picker>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="15">
                <label for="firstBlType">B/L Type</label>
                <model-list-select
                  :list="blTypeList"
                  v-model="ffExoprtDetail.firstBlType"
                  option-value="blTypeVal"
                  option-text="blTypeTxt"
                  placeholder="Select B/L Type"
                  isDisabled
                ></model-list-select>
              </md-layout>

              <md-layout md-flex="10">
                <md-radio
                  id="permitted1"
                  name="permitted1"
                  md-value="Original"
                  v-model="ffExoprtDetail.firstBLRadio"
                  class="md-primary"
                >Original</md-radio>
              </md-layout>

              <md-layout md-flex="10">
                <md-radio
                  id="permitted2"
                  name="permitted2"
                  v-model="ffExoprtDetail.firstBLRadio"
                  md-value="seaWayBl"
                  class="md-primary"
                >Sea Way</md-radio>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="10">
                <label for="deliveryTerms">Air Freight</label>
                <model-list-select
                  :list="oceanFreightTermsList"
                  v-model="ffExoprtDetail.firstOcFreghtTerms"
                  option-value="oceanFreightTermsVal"
                  option-text="oceanFreightTermsText"
                  placeholder="Select"
                ></model-list-select>
              </md-layout>
            </md-layout>-->
            <!-- <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="5"></md-layout>
              <span
                class="error"
                v-if="!ffExoprtDetail.firstBLNumber"
              >{{ffExporterrorList.firstBLNumber}}</span>
              <span class="error" v-else-if="blRegexError!=''">{{blRegexError}}</span>
            </md-layout>-->
            <!-- <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <md-input-container>
                  <label>Upload B/L</label>
                  <md-file
                    name="firstBLupload"
                    id="firstBLupload"
                    v-model="ffExoprtDetail.firstBLupload"
                    @selected="onFileChangeFirstBl"
                    multiple
                  ></md-file>
                </md-input-container>
              </md-layout>
            </md-layout>
            <md-layout md-gutter v-if="firstBlUploadView.length>0">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15" v-for="(item,index) in firstBlUploadView" :key="index">
                <a
                  :href="`${this.docURL}/dummy/`+item"
                  target="_blank"
                  download
                  v-if="ffExoprtDetail.ffairImportId==''"
                >View Document - {{index+1}}</a>
                <a
                  :href="`${this.docURL}/AirImportEntry/`+item"
                  target="_blank"
                  download
                  v-else
                >View Document - {{index+1}}</a>
              </md-layout>
            </md-layout>-->
            <md-layout md-gutter class="labelMargtop">

              <md-layout md-flex="35">
                <label for="PORlocationId">Place of Receipt</label>
                <model-list-select @input="getLocationList($event,'Air_Port','IcdPOrtList')"
                  @searchchange="getLocationList($event,'Air_Port','IcdPOrtList')" :list="IcdPOrtListNew"
                  v-model="ffExoprtDetail.PORlocationId" option-value="pickupId" option-text="pickupLocation"
                  placeholder="Select Place of Receipt"></model-list-select>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="35">
                <label for="PODLocationId">Airport of Departure</label>
                <model-list-select @input="getLocationList($event,'Air_Port','getPortDischargeList')"
                  @searchchange="getLocationList($event,'Air_Port','getPortDischargeList')" :list="PortDischargeList"
                  v-model="ffExoprtDetail.PODLocationId" option-value="pickupId" option-text="pickupLocation"
                  placeholder="Select POD"></model-list-select>
              </md-layout>

              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="20">
                <label>ETD @ Origin Port</label>
                <date-picker :format="selectDateFormat" lang="en" id="etaDischargePort" name="etaDischargePort"
                  v-model="ffExoprtDetail.etaDischargePort"></date-picker>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="labelMargtop">

              <md-layout md-flex="35">
                <span class="error" v-if="!ffExoprtDetail.PORlocationId">{{ffExporterrorList.PORlocationId}}</span>
              </md-layout>
              <md-layout md-flex="25">
                <span class="error" v-if="!ffExoprtDetail.LPlocationId">{{ffExporterrorList.LPlocationId}}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="labelMargtop">

              <md-layout md-flex="35">
                <label for="LPlocationId">Airport of Arrival</label>
                <model-list-select @input="getLocationList($event,'Air_Port','PortLoadList')"
                  @searchchange="getLocationList($event,'Air_Port','PortLoadList')" :list="PortLoadList"
                  v-model="ffExoprtDetail.LPlocationId" option-value="pickupId" option-text="pickupLocation"
                  placeholder="Select Arrival Port Name"></model-list-select>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="35">
                <label for="finalPlaceLocationId">Final Place of Delivery</label>
                <model-list-select @input="getLocationList($event,'All','finalAllPlaceData')"
                  @searchchange="getLocationList($event,'All','finalAllPlaceData')" :list="finalAllPlaceData"
                  v-model="ffExoprtDetail.finalPlaceLocationId" option-value="pickupId" option-text="pickupLocation"
                  placeholder="Select FPOD"></model-list-select>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="20">
                <label>ETA @ Arrival Port</label>
                <date-picker :format="selectDateFormat" lang="en" id="etaArrivalPort" name="etaArrivalPort"
                  v-model="ffExoprtDetail.etaArrivalPort"></date-picker>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="labelMargtop">


              <md-layout md-flex="25">
                <span class="error" v-if="!ffExoprtDetail.PODLocationId">{{ffExporterrorList.PODLocationId}}</span>
              </md-layout>

              <md-layout md-flex="10"></md-layout>
              <span class="error"
                v-if="!ffExoprtDetail.finalPlaceLocationId">{{ffExporterrorList.finalPlaceLocationId}}</span>
            </md-layout>
            <md-layout md-gutter class="labelMargtop">


              <md-layout md-flex="35">
                <label>Flight No.</label>
                <b-form-input :formatter="capitalizeAll" id="vesselVoyage" name="vesselVoyage"
                  v-model="ffExoprtDetail.vesselVoyage"></b-form-input>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="60">
                <label>Pre Carriage By</label>
                <b-form-input :formatter="capitalizeAll" id="preCarriageBy" name="preCarriageBy"
                  v-model="ffExoprtDetail.preCarriageBy"></b-form-input>
              </md-layout>
            </md-layout>

            <md-layout gutter class="labelMargtop">

              <md-layout md-flex="25">
                <label>Marks & Nos.</label>
                <b-form-textarea :formatter="capitalizeAll" id="marksNos" name="marksNos"
                  v-model="ffExoprtDetail.marksNos"></b-form-textarea>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <label>Description of Goods</label>
                <b-form-textarea :formatter="capitalizeAll" id="descriptionGood" name="descriptionGood"
                  v-model="ffExoprtDetail.descriptionGood"></b-form-textarea>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="35">
                <label>Commodity Name, HSN Code and Type</label>
                <b-form-textarea :formatter="capitalizeAll" id="commodity" name="commodity"
                  v-model="ffExoprtDetail.commodity"></b-form-textarea>
              </md-layout>
            </md-layout>

            <md-layout gutter class="labelMargtop">

              <md-layout md-flex="25">
                <label>Total No. Of Packages</label>
                <b-form-input :formatter="capitalizeAll" id="grossWeight" name="grossWeight" disabled
                  v-model="ffExoprtDetail.noOfPkg"></b-form-input>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="15">
                <label>Gross Wgt. of Cargo</label>
                <b-form-input :formatter="capitalizeAll" id="grossWeightCargo" name="grossWeightCargo"
                  v-model="ffExoprtDetail.grossWeightCargo"></b-form-input>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="15">
                <label>Volume Wgt. of Cargo</label>
                <b-form-input :formatter="capitalizeAll" id="Measurement" name="Measurement"
                  v-model="ffExoprtDetail.volumeWeightCargo"></b-form-input>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <label for="deliveryMode">Final Chargeable Weight</label>
                <b-form-input :formatter="capitalizeAll" id="Measurement" name="Measurement"
                  v-model="ffExoprtDetail.finalChargeableWeight"></b-form-input>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
            </md-layout>
            <md-layout gutter class="labelMargtop">

              <md-layout md-flex="100">
                <label>Remarks</label>
                <b-form-textarea :formatter="capitalizeAll" id="remarks" name="remarks"
                  v-model="ffExoprtDetail.ffExportremarks"></b-form-textarea>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="mt-4"
              v-if="ffExoprtDetail.containerInfo=='Consolidation' && multipleHouseBLData.length>0">
              <md-layout md-flex="85"></md-layout>

              <md-layout md-flex="15">
                <b-button variant="outline-info" size="sm" @click="showMoreShipper">{{openShipper==true?"Hide":"Add More"}} House BL</b-button>

                <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
              </md-layout>
            </md-layout>
            <div class="gutr mt-3">
              <h5>
                <b-badge>Importer Details( House B/L Wise)</b-badge>
              </h5>

              <div v-if="multipleHouseBLData.length==0 || openShipper==true">
                <b-card style="background:whiteSmoke">
                  <md-layout md-gutter class="labelMargtop">

                    <md-layout md-flex="45">
                      <label for="clientId">Importer Name</label>

                      <model-list-select :list="clientList" id="clientNamenew" v-model="ffHouseBL.importerClientId"
                        option-value="clientId" option-text="clientName"
                        placeholder="Select Importer Name"></model-list-select>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="50">
                      <label for="clientId">Exporter Name</label>

                      <model-list-select :list="clientList" id="clientNamenew" v-model="ffHouseBL.exporterClientId"
                        option-value="clientId" option-text="clientName"
                        placeholder="Select Exporter Name"></model-list-select>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                  </md-layout>
                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="40">
                      <span class="error" v-if="!ffHouseBL.importerClientId">{{errorHouseBL.importerClientId}}</span>
                    </md-layout>
                    <md-layout md-flex="15"></md-layout>
                    <span class="error" v-if="!ffHouseBL.exporterClientId">{{errorHouseBL.exporterClientId}}</span>
                  </md-layout>
                  <!-- <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="15">
                      <h4 style="margin:0px" class="showMoreData" @click="addNew">Add New Client</h4>
                    </md-layout>
                  </md-layout>-->
                  <md-layout gutter class="labelMargtop">
                    <md-layout md-flex="35" v-for="(singleInput, index) in ffHouseBL.notifyList" :key="index">
                      <md-layout md-flex="100">

                        <md-layout md-flex="60">
                          <label>{{ notifyArray[index] }} Notify Name & Address</label>
                        </md-layout>
                        <md-layout md-flex="15" v-if="index>1">
                          <md-button class="md-icon-button md-raised md-dense" @click="removeNotify(index)"
                            style="min-height:20px;height:20px">
                            <md-icon>close</md-icon>
                          </md-button>
                        </md-layout>
                      </md-layout>

                      <md-layout md-flex="100">

                        <md-layout md-flex="70">
                          <quill-editor ref="myTextEditor" v-model="singleInput.inputValue"></quill-editor>
                        </md-layout>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <md-layout gutter class="mt-2">

                    <md-layout md-flex="30">
                      <b-button size="sm" variant="outline-dark" @click="addNotify">Add Notify</b-button>
                      <md-spinner md-indeterminate id="loader1" style="display:none"></md-spinner>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="labelMargtop">

                    <md-layout md-flex="15">
                      <label>Air B/L Number</label>
                      <b-form-input :formatter="capitalizeAll" id="secondBLNumber" name="secondBLNumber"
                        v-model="ffHouseBL.secondBLNumber"></b-form-input>
                      <!-- @keyup="houseBLRegexfun" -->
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="15">
                      <label>B/L Date</label>
                      <date-picker :format="selectDateFormat" lang="en" id="secondBLDate" name="secondBLDate"
                        v-model="ffHouseBL.secondBLDate"></date-picker>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="15">
                      <label for="secondBlType">B/L Type</label>
                      <model-list-select :list="blTypeList" v-model="ffHouseBL.secondBlType" option-value="blTypeVal"
                        option-text="blTypeTxt" placeholder="Select B/L Type"></model-list-select>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <!-- <md-layout md-flex="5"></md-layout> -->
                    <md-layout md-flex="10">
                      <md-radio id="permitted1" name="permitted1" md-value="Original" v-model="ffHouseBL.secondBLRadio"
                        class="md-primary mt-3">Original</md-radio>
                    </md-layout>

                    <md-layout md-flex="10">
                      <md-radio id="permitted2" name="permitted2" v-model="ffHouseBL.secondBLRadio" md-value="seaWayBl"
                        class="md-primary">Sea Way</md-radio>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="15">
                      <label for="secondOcFreghtTerms">Air Freight</label>
                      <model-list-select :list="oceanFreightTermsList" v-model="ffHouseBL.secondOcFreghtTerms"
                        option-value="oceanFreightTermsVal" option-text="oceanFreightTermsText"
                        placeholder="Select"></model-list-select>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="5"></md-layout>
                    <span class="error" v-if="!ffHouseBL.secondBLNumber">{{errorHouseBL.secondBLNumber}}</span>
                    <!-- <span class="error" v-else-if="houseblRegexError!=''">{{houseblRegexError}}</span> -->
                  </md-layout>
                  <md-layout md-gutter class="labelMargtop">

                    <md-layout md-flex="35">
                      <md-layout md-flex="100">
                        <md-input-container>
                          <label>Upload B/L</label>
                          <md-file name="secondBLupload" id="secondBLupload" v-model="ffHouseBL.secondBLupload" multiple
                            @selected="onFileChangeSecondBl"></md-file>
                        </md-input-container>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter v-if="SecondBlUploadView.length>0">

                    <md-layout md-flex="15" v-for="(item,index) in SecondBlUploadView" :key="index">
                      <a :href="`${docURL}/FF_Air_Import_Uploads/`+item" target="_blank" download>View Document -
                        {{index+1}}</a>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="labelMargtop">

                    <md-layout md-flex="35">
                      <label for="deliveryTerms">Delivery Terms(INCOTERMS)</label>
                      <model-list-select :list="deliveryTermsList" v-model="ffHouseBL.deliveryTerms"
                        option-value="deliveryTermsVal" option-text="deliveryTermsText"
                        placeholder="Select Delivery Terms"></model-list-select>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="20">
                      <!-- <h4 style="padding:0px;margin:0px"></h4> -->
                      <label for="ccType">Custom Clearence Type</label>
                      <model-list-select :list="cctypeList" v-model="ffHouseBL.ccType" option-value="ccTypeVal"
                        option-text="ccTypeTxt" placeholder="Select  Type"></model-list-select>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="35" v-if="ffHouseBL.ccType=='Outsourced'">
                      <label>CHA Name</label>
                      <b-form-input :formatter="capitalizeAll" id="ccCha" name="ccCha"
                        v-model="ffHouseBL.ccCha"></b-form-input>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="labelMargtop">
                    <md-layout md-flex="35"></md-layout>
                    <span class="error" v-if="!ffHouseBL.ccType">{{errorHouseBL.ccType}}</span>
                  </md-layout>
                  <md-layout md-gutter class="labelMargtop">

                    <md-layout md-flex="35">
                      <label for="deliveryMode">Destination Delivery Mode</label>
                      <model-list-select :list="deliveryModeList" v-model="ffHouseBL.houseDeliveryMode"
                        option-value="deliveryModeVal" option-text="deliveryModeText"
                        placeholder="Select Delivery Mode"></model-list-select>
                    </md-layout>

                    <md-layout md-flex="5" v-if="ffHouseBL.houseDeliveryMode=='DOOR'"></md-layout>
                    <md-layout md-flex="25" v-if="ffHouseBL.houseDeliveryMode=='DOOR'">
                      <label for="finalPlaceLocationId">Door FPOD</label>
                      <model-list-select :list="allLocationList" v-model="ffHouseBL.doorFPOd" option-value="pickupId"
                        option-text="pickupLocation" placeholder="Select FPOD"></model-list-select>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="25">
                      <label for="shipmentType">Source Of Booking</label>
                      <!-- shipType is for source of booking -->
                      <model-list-select :list="shipTypeList" v-model="ffHouseBL.shipType" option-value="shipTypeVal"
                        option-text="shipTypeText" placeholder="Select Source Of Booking "></model-list-select>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="labelMargtop">

                    <md-layout md-flex="35" v-if="ffHouseBL.shipType=='Destination'">
                      <label for="agentName">Agent Name</label>
                      <model-list-select :list="agentNameList" v-model="ffHouseBL.agentName"
                        option-value="agntColoaderId" option-text="agentName"
                        placeholder="Select Agent Name"></model-list-select>
                    </md-layout>
                    <md-layout md-flex="35" v-if="ffHouseBL.shipType=='Origin'">
                      <label for="sourceOriginclientId">Client Name</label>
                      <model-list-select :list="clientList" id="clientNamenew" v-model="ffHouseBL.sourceOriginclientId"
                        option-value="clientId" option-text="clientName"
                        placeholder="Select Client Name"></model-list-select>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="25" v-if="ffHouseBL.shipType=='Destination'">
                      <label>Buyer Name</label>
                      <b-form-input :formatter="capitalizeAll" id="buyer" name="buyer"
                        v-model="ffHouseBL.buyer"></b-form-input>
                    </md-layout>

                    <md-layout md-flex="25" v-if="ffHouseBL.shipType=='Origin'">
                      <label>Enter Buying House</label>
                      <b-form-input :formatter="capitalizeAll" id="buyingHouse" name="buyingHouse"
                        v-model="ffHouseBL.buyingHouse"></b-form-input>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30" v-if="ffHouseBL.shipType=='Origin'">
                      <label>Other Specify</label>
                      <b-form-input :formatter="capitalizeAll" id="otherSpecify" name="otherSpecify"
                        v-model="ffHouseBL.otherSpecify"></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout gutter class="labelMargtop">

                    <md-layout md-flex="30">
                      <label>Marks & Nos.</label>
                      <b-form-textarea :formatter="capitalizeAll" id="houseMarksNos" name="houseMarksNos"
                        v-model="ffHouseBL.houseMarksNos"></b-form-textarea>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="35">
                      <label>Container No./ Seal No.</label>
                      <b-form-textarea :formatter="capitalizeAll" id="houseContainerSealNo" name="houseContainerSealNo"
                        v-model="ffHouseBL.houseContainerSealNo"></b-form-textarea>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="25">
                      <label>Commodity Name, HSN Code and Type</label>
                      <b-form-textarea :formatter="capitalizeAll" id="houseCommodity" name="houseCommodity"
                        v-model="ffHouseBL.houseCommodity"></b-form-textarea>
                    </md-layout>
                  </md-layout>

                  <md-layout gutter class="labelMargtop">

                    <md-layout md-flex="20">
                      <label>Total No. Of Packages</label>
                      <b-form-input :formatter="capitalizeAll" id="houseNoOfPkg" name="houseNoOfPkg"
                        v-model="ffHouseBL.houseNoOfPkg"></b-form-input>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="15">
                      <label>Gross Wgt. of Cargo</label>
                      <b-form-input :formatter="capitalizeAll" id="houseGrossWeightCargo" name="houseGrossWeightCargo"
                        v-model="ffHouseBL.houseGrossWeightCargo"></b-form-input>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>

                    <md-layout md-flex="20">
                      <label>Volume Wgt. of Cargo</label>
                      <b-form-input :formatter="capitalizeAll" id="Measurement" name="Measurement"
                        v-model="ffHouseBL.houseVolumeWeightCargo"></b-form-input>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30">
                      <label for="deliveryMode">Final Chargeable Weight</label>
                      <b-form-input :formatter="capitalizeAll" id="Measurement" name="Measurement"
                        v-model="ffHouseBL.houseFinalChargeableWeight"></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout gutter class="labelMargtop">


                    <md-layout md-flex="100">
                      <label>Description of Goods</label>
                      <b-form-textarea :formatter="capitalizeAll" id="houseDescriptionGood" name="houseDescriptionGood"
                        v-model="ffHouseBL.houseDescriptionGood"></b-form-textarea>
                    </md-layout>
                  </md-layout>
                  <md-layout gutter class="labelMargtop">

                    <md-layout md-flex="100">
                      <label>Remarks</label>
                      <b-form-textarea :formatter="capitalizeAll" id="remarks" name="remarks"
                        v-model="ffHouseBL.remarks"></b-form-textarea>
                    </md-layout>
                  </md-layout>

                  <md-layout md-gutter class="mrgtop-button">

                    <b-button class="mt-3" size="sm" variant="info" id="addButtonLoader"
                      @click="addFFSeaImport('')">Save</b-button>
                    <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
                  </md-layout>
                </b-card>
              </div>
              <table id="conBooking" class="table table-bordered gutr" v-if="multipleHouseBLData.length>0">
                <thead>
                  <tr>
                    <th>Sr no</th>

                    <th>Importer Name</th>
                    <th>Exporter Name</th>
                    <th>House BL Number</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item1,index) in multipleHouseBLData" :key="index">
                    <td>{{index+1}}</td>

                    <td>{{item1.ImporterName}}</td>
                    <td>{{item1.ExporterName }}</td>
                    <td>{{item1.secondBLNumber}}</td>
                    <td>
                      <b-button size="sm" variant="outline-info" @click="EditHouseBL(item1)">Edit</b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <md-layout md-gutter class="mrgtop-button gutr"
              v-if="multipleHouseBLData.length>0 && ffHouseBL.ffAirMultiBlId==''">

              <b-button class="mt-3" variant="primary" id="addButtonLoader" @click="addFFSeaImport('fdsf')">Save &
                Proceed to Execution</b-button>
              <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
            </md-layout>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="alertAddSeaImp"
      @close="onCloseAddSeaImp"></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import {
  globalPermissionStatus,
  GlobalGetLocation
} from "../../helper/collection";
import VueTrix from "vue-trix";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import CustomLoader from "../common/customLoader.vue";

import { quillEditor } from "vue-quill-editor";

export default {
  beforeMount() {
    if (globalPermissionStatus("Air Freight")) {
      this.$store.dispatch("setCurrentRoute", "/airImport/ffairImportFcl");
      this.getServicesData();
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  watch: {},
  data() {
    return {
      selectDateFormat,
      docURL: URL_BASE_DOC,
      editorOption: {
        modules: {}
      },
      editorContent: "",
      isLoading: false,
      transportTypeList: [
        {
          transportTypeVal: "AirImport",
          transportTypeText: "Air"
        }
      ],
      blTypeList: [
        {
          blTypeVal: "HouseBL",
          blTypeTxt: "House B/L"
        },

        {
          blTypeVal: "MasterBL",
          blTypeTxt: "Master B/L"
        }
      ],
      blTypeListLcl: [
        {
          blTypeVal: "HouseBL",
          blTypeTxt: "House B/L"
        },

        {
          blTypeVal: "Co-Loader",
          blTypeTxt: "Co-Loader"
        }
      ],

      cctypeList: [
        {
          ccTypeVal: "Own",
          ccTypeTxt: "Own"
        },
        {
          ccTypeVal: "Outsourced",
          ccTypeTxt: "Outsourced"
        },
        {
          ccTypeVal: "N/A",
          ccTypeTxt: "N/A"
        }
      ],

      containerInfoList: [
        {
          containerInfoVal: "Normal",
          containerInfoText: "FCL"
        },
        {
          containerInfoVal: "Consolidation",
          containerInfoText: "FCL Consol"
        }
      ],
      deliveryModeList: [
        {
          deliveryModeVal: "uptoAirport",
          deliveryModeText: "upto Airport "
        },
        {
          deliveryModeVal: "DOOR",
          deliveryModeText: "DOOR"
        }
      ],

      deliveryTermsList: [
        {
          deliveryTermsVal: "ExWorks",
          deliveryTermsText: "Ex-Works"
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP"
        },
        {
          deliveryTermsVal: "DAP",
          deliveryTermsText: "DAP"
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP"
        },
        {
          deliveryTermsVal: "FOB_POR",
          deliveryTermsText: "FOB_POR_"
        },
        {
          deliveryTermsVal: "FOB_LoadPort",
          deliveryTermsText: "FOB_LoadPort_"
        },
        {
          deliveryTermsVal: "FCA",
          deliveryTermsText: "FCA"
        },
        {
          deliveryTermsVal: "FAS",
          deliveryTermsText: "DDP"
        },
        {
          deliveryTermsVal: "CFR",
          deliveryTermsText: "CFR"
        },
        {
          deliveryTermsVal: "CIF",
          deliveryTermsText: "CIF"
        },
        {
          deliveryTermsVal: "CIP",
          deliveryTermsText: "CIP"
        },
        {
          deliveryTermsVal: "CPT",
          deliveryTermsText: "CPT"
        },
        {
          deliveryTermsVal: "DAF",
          deliveryTermsText: "DAF"
        },
        {
          deliveryTermsVal: "DES",
          deliveryTermsText: "DES"
        },
        {
          deliveryTermsVal: "DEQ",
          deliveryTermsText: "DEQ"
        }
      ],

      oceanFreightTermsList: [
        {
          oceanFreightTermsVal: "prepaid",
          oceanFreightTermsText: "Prepaid"
        },
        {
          oceanFreightTermsVal: "collect",
          oceanFreightTermsText: "Collect"
        }
      ],

      showAdd: false,

      shipTypeList: [
        {
          shipTypeVal: "Origin",
          shipTypeText: "Origin"
        },
        {
          shipTypeVal: "Destination",
          shipTypeText: "Destination"
        }
      ],

      agentListName: [
        {
          agentNameVal: "agentName1",
          agentNameText: "agentName1"
        },
        {
          agentNameVal: "agentName2",
          agentNameText: "agentName2"
        }
      ],

      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      allAgentColoader: [],
      CommodityAll: {},
      autoClientName: {},
      notifyArray: [
        "",
        "Second",
        "Third",
        "Fourth",
        "FiFth",
        "Sixth",
        "Seventh",
        "Eight",
        "Ninth",
        "Tenth"
      ],
      notifyListArray: [
        "",
        "Second",
        "Third",
        "Fourth",
        "Fifth",
        "Sixth",
        "Seven",
        "Eight"
      ],
      blRegexError: "",
      // houseblRegexError: "",

      ffHouseBL: {
        ffAirMultiBlId: "",
        secondBLNumber: "",
        secondBLDate: "",
        secondBlType: "HouseBL",
        secondBLRadio: "",
        secondOcFreghtTerms: "",
        secondBLupload: "",
        importerClientId: "",
        exporterClientId: "",
        notifyList: [
          {
            inputValue: "",
            text: ""
          },
          {
            inputValue: "",
            text: "Second"
          }
        ],
        ccType: "",
        ccCha: "",
        shipType: "",
        agentName: "",
        sourceOriginclientId: "",
        buyer: "",
        buyingHouse: "",
        otherSpecify: "",
        houseMarksNos: "",
        houseContainerSealNo: "",
        houseDeliveryMode: "",
        houseCommodity: "",
        houseDescriptionGood: "",
        doorFPOd: "",
        houseNoOfPkg: "",
        houseVolumeWeightCargo: "",
        houseFinalChargeableWeight: "",
        deliveryTerms: "",
        remarks: "",
        houseGrossWeightCargo: ""
      },

      errorHouseBL: {
        secondBLNumber: "",
        importerClientId: "",
        exporterClientId: "",
        ccType: ""
      },
      multipleHouseBLData: [],

      arrayErrorHouseBL: {
        secondBLNumber: "Enter B/L Number",
        importerClientId: "Select Importer Name",
        exporterClientId: "Select Exporter Name",
        ccType: "Select CC Type"
      },
      ffExoprtDetail: {
        allModuleId:"",
        ffairImportId: "",
        airImportSeries:"",
        jobType: [],
        transportType: "AirImport",
        containerInfo: "",
        airlineId: "",
        flightDate: "",
        alertReceivedDate: "",
        firstBLNumber: "",
        firstBLDate: "",
        firstBlType: "MasterBL",
        firstBLRadio: "",
        firstOcFreghtTerms: "",
        firstBLupload: "",
        preCarriageBy: "",
        PORlocationId: "",
        PODLocationId: "",
        etaArrivalPort: "",
        vesselVoyage: "",
        LPlocationId: "",
        finalPlaceLocationId: "",
        etaDischargePort: "",
        marksNos: "",
        descriptionGood: "",
        commodity: "",
        noOfPkg: "",
        volumeWeightCargo: "",
        finalChargeableWeight: "",
        grossWeightCargo: "",
        ffExportremarks: "",
        statusFinal: ""
      },
      getDayFromDate: "",

      deleteId: "",

      shippingIdError: "",
      totalContainer: "",
      noOfContainerError: "",
      containerTypeIdError: "",

      fobReceiptName: "",
      fobLoadPortName: "",
      commodityArray: [],
      getPortData: ["Agra"],

      error: {
        clientNameError: "",
        toPortError: "",
        fromPortError: "",
        transhipmentNameError: "",
        addOneTranError: ""
      },
      getCLientData: ["gfdg"],
      showSegmentArray: [],

      driverNameDetail: ["iji"],
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "New"
      },
      errorAtleastOne: "",
      ffExportError: [
        "Select Type",
        "Select AirLine Name",
        "Select flight Date",
        "Select Pre-Alert Date",
        // "Enter BL Number",

        "Select Place of Recipt",

        "Select Port Of Discharge",
        "Select Arrival Port",
        "Select Final Place Delivery"
      ],
      ffExporterrorList: {
        containerInfo: "",
        airlineId: "",
        flightDate: "",
        alertReceivedDate: "",
        // firstBLNumber: "",
        PORlocationId: "",
        PODLocationId: "",
        LPlocationId: "",
        finalPlaceLocationId: ""
      },
      getPortDischargeList: [],
      finalAllPlaceData: [],
      PortLoadList: [],
      shipmentTypeName: [
        {
          shipmentTypeVal: "Sea_Shipment",
          shipmentTypeText: "Sea Shipment"
        },
        {
          shipmentTypeVal: "Air_Shipment",
          shipmentTypeText: "Air_Shipment"
        }
      ],
      jobTypeSelectVal: false,
      otherServicesVal: false,
      openShipper: false,

      getShippingLineData: ["zim"],
      getCommodityData: ["zim"],
      getContainerTypeData: ["zim"],
      getlocationListData: ["agra"],
      getAlllocationListData: ["agra"],
      IcdPOrtList: ["agra"],
      validate: true,
      clientNameError: "",
      addDriverError1: "",
      addTruckError4: "",
      ExecutionDisable: ""
    };
  },

  mounted() {},
  beforeDestroy() {
    // this.$sessionsStorage.set("editExportFCLId", "");
  },
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    Loading,
    VueTrix,
    quillEditor,
    CustomLoader,
    BannerComponent,
  },
  computed: {
    clientList() {
      return this.getCLientData;
    },
    ContainerTypeList() {
      return this.getContainerTypeData;
    },
    shippingList() {
      return this.getShippingLineData;
    },
    locationList() {
      return this.getlocationListData;
    },
    IcdPOrtListNew() {
      return this.IcdPOrtList;
    },

    PortDischargeList() {
      return this.getPortDischargeList;
    },
    allLocationList() {
      return this.getAlllocationListData;
    },
    PortList() {
      return this.getPortData;
    },
    viewDocument() {
      return this.ffExoprtDetail.uploadDriverDoc.split(",");
    },
    vehicleMasterList() {
      return this.driverNameDetail;
    },
    commodityList() {
      return this.getCommodityData;
    },

    prepaidDetailsList() {
      return this.prepaidDetailsName;
    },
    collectDetailsList() {
      return this.collectDetailsName;
    },

    agentNameList() {
      return this.getagentName;
    },
    getColoaderNameList() {
      return this.getColoaderName;
    },
    firstBlUploadView() {
      return this.ffExoprtDetail.firstBLupload != ""
        ? this.ffExoprtDetail.firstBLupload.split(",")
        : [];
    },
    SecondBlUploadView() {
      return this.ffHouseBL.secondBLupload != ""
        ? this.ffHouseBL.secondBLupload.split(",")
        : [];
    }
  },
  methods: {
    addStatus() {
      let data = {
        jobType: "1",
        typeOf: "3",
        allMessageId: this.$sessionsStorage.get("editffAirImportId"),
        statusMain: this.ffExoprtDetail.statusFinal
      };

      this.$sessionsStorage.set("MessageStatus", JSON.stringify(data));

      this.$router.push({
        path: "/UpdateStatus/internalAssignStatus"
      });
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function(error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    onCloseAddSeaImp() {
      this.$router.push({
        path: "/airImport/airImportExec"
      });
    },

    addNotify() {
      let obj = {
        inputValue: "",
        text: this.notifyArray[this.ffExoprtDetail.notifyList.length]
      };
      this.ffHouseBL.notifyList.push(obj);
    },
    removeNotify(index) {
      this.ffHouseBL.notifyList.splice(index, 1);
    },
    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    jobTypeSelect(value, index) {
      if (value == "All") {
        if (this.jobTypeSelectVal == false) {
          this.ffExoprtDetail.jobType = Array(
            this.showSegmentArray.length
          ).fill(true);
          this.jobTypeSelectVal = true;
        } else {
          this.ffExoprtDetail.jobType = Array(
            this.showSegmentArray.length
          ).fill(false);
          this.jobTypeSelectVal = false;
        }
      }
    },

    validateFFExport(id) {
      let validate_new = true;
      let id22 = 0;

      var blformat = new RegExp("^[0-9]{11}$");

      // if (blformat.test(this.ffExoprtDetail.firstBLNumber)) {
      //   this.blRegexError = "";
      // } else {
      //   this.blRegexError = "Enter Valid Format";
      //   validate_new = false;
      //   window.scroll(0, 200);
      // }

      Object.keys(this.ffExporterrorList).map((x, index) => {
        if (this.ffExoprtDetail[x] == "") {
          this.ffExporterrorList[x] = this.ffExportError[index];
          validate_new = false;
          id22 = 1;
        }
      });
      if (id == "") {
        // if (blformat.test(this.ffHouseBL.secondBLNumber)) {
        //   this.houseblRegexError = "";
        // } else {
        //   this.houseblRegexError = "Enter Valid Format";
        //   validate_new = false;
        //   if (id22 == 0) {
        //     id22 = 2;
        //   }
        // }
        Object.keys(this.errorHouseBL).map((x, index) => {
          if (this.ffHouseBL[x] == "") {
            this.errorHouseBL[x] = this.arrayErrorHouseBL[x];
            validate_new = false;
            if (id22 == 0) {
              id22 = 2;
            }
          }
        });
      }
      if (validate_new != true) {
        if (id22 == 1) {
          window.scroll(0, 100);
        } else if (id22 == 2) {
          window.scroll(0, 870);
        }

        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    addFFSeaImport(id) {
      // $("#clientId").focus();
      let newVal = [];
      this.showSegmentArray.map((x, index) => {
        if (this.ffExoprtDetail.jobType[index] == true) {
          newVal.push(x.value);
        }
      });
      this.ffExoprtDetail["jobTypeArry"] = newVal;

      this.validateFFExport(id);

      let new_data = {
        ffExoprtDetail: this.ffExoprtDetail,
        ffHouseBL: this.ffHouseBL
      };

      if (id == "") {
        new_data["onlyExecMain"] = "";
      } else {
        new_data["onlyExecMain"] = "csfds";
      }

      // console.log(new_data);
      // return false;
      if (this.validate != false) {
        $("#addButtonLoader1212").css("display", "none");
        $("#loader11212").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_AirImport/addAirFFExport.php`,
          data: JSON.stringify(new_data),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;

            if ( status == 200 && data) {
              this.$sessionsStorage.set(
                "editffAirImportId",
                data.ffairImportId
              );
              console.log(data);
              this.ffExoprtDetail.ffairImportId = data.ffairImportId;
              $("#loader11212").css("display", "none");
              $("#addButtonLoader11212").css("display", "block");

              this.openShipper = false;
              if (id != "") {
                this.alert.content = "Data Updated Succesfully";
                this.$refs["alertAddSeaImp"].open();
              }
              Object.keys(this.ffHouseBL).map(x => {
                if (x == "notifyList") {
                  this.ffHouseBL[x] = [
                    {
                      inputValue: "",
                      text: ""
                    },
                    {
                      inputValue: "",
                      text: "Second"
                    }
                  ];
                } else {
                  this.ffHouseBL[x] = "";
                }
              });

              Object.keys(this.errorHouseBL).map(x => {
                this.errorHouseBL[x] = "";
              });
              Object.keys(this.ffExporterrorList).map(x => {
                this.ffExporterrorList[x] = "";
              });
              this.getData();
            }
          })
          .catch(error => {});
      }
    },

    EditHouseBL(item) {
      console.log(item);
      this.ffHouseBL.notifyList = [];
      this.openShipper = true;
      Object.keys(this.ffHouseBL).map(x => {
        if (x == "notifyList") {
          item[x].split("$$$").map((y, index) => {
            let obj = {
              inputValue: y,
              text: this.notifyListArray[index]
            };

            this.ffHouseBL.notifyList.push(obj);
          });
        } else {
          this.ffHouseBL[x] = item[x] || "";
        }
      });
    },
    onFileChangeFirstBl() {
      var files = event.target.files || event.dataTransfer.files;

      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
      }
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: this.$sessionsStorage.get("editSeaNormalTrackId")
        }
      };

      axios
        .post(`${URL_BASE}//SeaImport/uploadSeaImportDoc.php`, formData, config)
        .then(result => {
          this.ffExoprtDetail.firstBLupload = result.data;
          // console.log("fdsf", result.data);
        })
        .catch(err => {
          throw err;
        });
    },

    containerNoRegexfun() {
      var blformat = new RegExp("^[0-9]{11}$");
      let arrayLen = [];

      if (blformat.test(this.ffExoprtDetail.firstBLNumber)) {
        this.blRegexError = "";
      } else {
        this.blRegexError = "Enter Valid Format";
      }

      // if (this.ffExoprtDetail.firstBLNumber == "") {
      //   arrayLen = this.containerTypeDetailFactoryList.filter(x => {
      //     return x.firstBLNumber == this.ffExoprtDetail.firstBLNumber;
      //   });
      // }

      // if (
      //   arrayLen.length > 0 &&
      //   this.ffExoprtDetail.firstBLNumber == ""
      // ) {
      //   this.containerNoRegexError = "Already Exist";
      // } else
    },

    // houseBLRegexfun() {
    //   var blformat = new RegExp("^[0-9]{11}$");
    //   let arrayLen = [];

    //   if (blformat.test(this.ffHouseBL.secondBLNumber)) {
    //     this.houseblRegexError = "";
    //   } else {
    //     this.houseblRegexError = "Enter Valid Format";
    //   }

    // },

    onFileChangeSecondBl() {
      let files = event.target.files || event.dataTransfer.files;

      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
        formData.append(
          "moduleId",
          this.$sessionsStorage.get("editffAirImportId")
        );

        formData.append("staticFileName", "Air_Import_HouseBL");

        formData.append("upload_dir_folderName", "FF_Air_Import_Uploads");
      }

      const config = {
        headers: { "content-type": "multipart/form-data" }
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAll.php`, formData, config)
        .then(result => {
          this.ffHouseBL.secondBLupload = result.data;
        })
        .catch(err => {
          throw err;
        });
    },

    getData() {
      this.doLoading();
      let array = [];
      let vehicle_drive = {
        itemCode: "itemCode",
        ffairImportId: this.$sessionsStorage.get("editffAirImportId")
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_AirImport/getDataNormalSeaImport1.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.ffAirImportData.length > 0) {
              this.ffExoprtDetail.notifyList = [];
              Object.keys(this.ffExoprtDetail).map(x => {
                if (x == "jobType") {
                  array = data.ffAirImportData[0][x].split(",");
                } else {
                  this.ffExoprtDetail[x] = data.ffAirImportData[0][x] || "";
                }
              });
              this.ffExoprtDetail["jobType"] = [];
              this.showSegmentArray.map((x, index) => {
                let i = array.indexOf(x.value);
                // console.log(array, i);

                i >= 0
                  ? (this.ffExoprtDetail.jobType[index] = true)
                  : (this.ffExoprtDetail.jobType[index] = false);
              });
              if (data.ffAirImportData[0]["portType"] == "Icd") {
                this.IcdPOrtList = data.LocationDetailsFinal;
              } else {
                this.IcdPOrtList = data.LocationDetailsSEAPORT;
              }
            } else {
              this.IcdPOrtList = data.LocationDetailsSEAPORT;
            }

            this.getPortDischargeList = data.LocationDetailsSEAPORT;
            this.PortLoadList = data.LocationDetailsSEAPORT;
            this.finalAllPlaceData = data.LocationDetailsFinal;

            if (data.ffAirImportBL.length > 0) {
              this.multipleHouseBLData = data.ffAirImportBL;
            } else {
              this.multipleHouseBLData = [];
            }

            if (data.agentColoaderData.length > 0) {
              this.getagentName = data.agentColoaderData.filter(x => {
                return x.categoryType == "Agent";
              });

              this.getColoaderName = data.agentColoaderData.filter(x => {
                return x.categoryType == "CoLoader";
              });
            }
            if (data.clientdetail.length > 0) {
              this.getCLientData = data.clientdetail;
            }

            if (data.slineDetails.length > 0) {
              this.getShippingLineData = data.slineDetails;
            }

            this.doLoadingClose();
            this.JqueryFun();
          }
        })
        .catch(error => {});
    },
    addNew() {
      this.$router.push({
        path: "/client/addClient"
      });
    },

    previousFFView() {
      this.$router.push({
        path: "/airImport/viewAirImportDetails"
      });
    },
    showMoreShipper() {
      if (this.openShipper == false) {
        this.openShipper = true;
      } else {
        this.openShipper = false;
      }
    },
    getServicesData() {
      this.showSegmentArray = [
        {
          value: "Freight_Forwarding",
          show: "Freight Forwarding(FF)",
          flex: "20"
        },
        {
          value: "Customs_Clearance",
          show: "Customs Clearance(CC)",
          flex: "20"
        },
        {
          value: "Transportation",
          show: "Transportation(TPT)",
          flex: "20"
        },

        {
          value: "All",
          show: "All",
          flex: "15"
        }
      ];
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// ffairImportFcl.vue?5329c928